







import React, { useEffect, useState } from 'react';
import { MsalProvider, useMsal, useIsAuthenticated } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';
import LoginPage from './LoginPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RecordDetailPage from './RecordDetailPage';
import ClientDetailsPage from './ClientDetailsPage';
import ProductTypeDetailsPage from './ProductTypeDetailsPage';
import RoutingRulesEditorPage from './RoutingRulesEditorPage';
import RoutingRulesEditorForm from './RoutingRulesEditorForm';
import TemplatesAdminPage from './TemplatesAdminPage';
import { Grid, Card, CardContent, Typography, Box, Button, ButtonGroup, Menu, MenuItem } from '@mui/material';
import LatestTransactionsTable from './LatestTransactionsTable';
import NotVerifiedNotImportedPage from './NotVerifiedNotImportedPage';
import BarChartIcon from '@mui/icons-material/BarChart';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
function MainApp() {
  const [page, setPage] = useState('dashboard');
  const [anchorElActions, setAnchorElActions] = useState(null);
  const [anchorElStats, setAnchorElStats] = useState(null);
  const [anchorElAdmin, setAnchorElAdmin] = useState(null);
  const [summary, setSummary] = useState({ total: 0, ok: 0, needsAction: 0 });
  const [chartData, setChartData] = useState([]);
  const isAuthenticated = useIsAuthenticated();// State and handlers
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000';

  // Sample productTypeCategoryMap, replace with your actual mapping if needed
  const productTypeCategoryMap = {
    'Bond': 'Fixed Income',
    'Equity': 'Stocks',
    'Option': 'Derivatives',
    'Swap': 'Derivatives',
    'Loan': 'Credit',
    // Add more mappings as needed
  };

  useEffect(() => {
    if (page === 'dashboard') {
      fetch(`${API_BASE_URL}/api/dashboard-summary`)
        .then(res => res.json())
        .then(data => {
          // Aggregate total from all keys
          const total = Object.values(data).reduce((sum, val) => sum + (typeof val === 'number' ? val : 0), 0);
          setSummary({
            total,
            ok: 0,
            needsAction: 0
          });
        });
      fetch(`${API_BASE_URL}/api/transactions-by-day`)
        .then(res => res.json())
        .then(data => setChartData(data || []));
    }
  }, [page]);
    if (!isAuthenticated) {
      return <LoginPage />;
    }
    return (
      <Router>
        <Routes>
          <Route path="/" element={
            <Box sx={{ p: 3, background: '#f5f5f5', minHeight: '100vh' }}>
              {/* ...existing dashboard code... */}
              <ButtonGroup sx={{ mb: 3 }}>
                <Button variant={page === 'dashboard' ? 'contained' : 'outlined'} onClick={() => setPage('dashboard')}>Dashboard</Button>
                <Button
                  variant={page === 'notVerifiedNotImported' ? 'contained' : 'outlined'}
                  onClick={event => setAnchorElActions(event.currentTarget)}
                >Actions</Button>
                <Button
                  variant={(page === 'productTypeDetails' || page === 'clientDetails') ? 'contained' : 'outlined'}
                  onClick={event => setAnchorElStats(event.currentTarget)}
                >Statistics</Button>
                <Button
                  variant={page === 'routingRulesEditor' ? 'contained' : 'outlined'}
                  onClick={event => setAnchorElAdmin(event.currentTarget)}
                >Admin</Button>
              </ButtonGroup>
              {/* ...existing dropdowns and page rendering... */}
              {/* Actions Dropdown */}
              <Menu anchorEl={anchorElActions} open={Boolean(anchorElActions)} onClose={() => setAnchorElActions(null)}>
                <MenuItem onClick={() => { setPage('notVerifiedNotImported'); setAnchorElActions(null); }}>Not Verified & Not Imported</MenuItem>
              </Menu>
              {/* Statistics Dropdown */}
              <Menu anchorEl={anchorElStats} open={Boolean(anchorElStats)} onClose={() => setAnchorElStats(null)}>
                <MenuItem onClick={() => { setPage('productTypeDetails'); setAnchorElStats(null); }}>Product Type Details</MenuItem>
                <MenuItem onClick={() => { setPage('clientDetails'); setAnchorElStats(null); }}>Client Details</MenuItem>
              </Menu>
              {/* Admin Dropdown */}
              <Menu anchorEl={anchorElAdmin} open={Boolean(anchorElAdmin)} onClose={() => setAnchorElAdmin(null)}>
                <MenuItem onClick={() => { setPage('routingRulesEditor'); setAnchorElAdmin(null); }}>Routing Rules Editor</MenuItem>
                <MenuItem onClick={() => { setPage('templatesAdmin'); setAnchorElAdmin(null); }}>Templates Admin</MenuItem>
              </Menu>
              {page === 'dashboard' ? (
                <Box>
                  <Typography variant="h3" gutterBottom>Ratex Dashboard</Typography>
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={4}>
                      <Card sx={{ bgcolor: '#1976d2', color: 'white', p: 2 }}>
                        <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 3 }}>
                          <Box sx={{ width: '100%', textAlign: 'center' }}>
                            <Typography variant="h6" sx={{ textAlign: 'center' }}>Total Transactions</Typography>
                            <Typography variant="h4" sx={{ textAlign: 'center', mt: 1 }}>{summary.total}</Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Card sx={{ bgcolor: '#43a047', color: 'white', p: 2 }}>
                        <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 3 }}>
                          <Box sx={{ width: '100%', textAlign: 'center' }}>
                            <Typography variant="h6" sx={{ textAlign: 'center' }}>OK</Typography>
                            <Typography variant="h4" sx={{ textAlign: 'center', mt: 1 }}>{summary.ok}</Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Card sx={{ bgcolor: '#e53935', color: 'white', p: 2 }}>
                        <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 3 }}>
                          <Box sx={{ width: '100%', textAlign: 'center' }}>
                            <Typography variant="h6" sx={{ textAlign: 'center' }}>Needs Action</Typography>
                            <Typography variant="h4" sx={{ textAlign: 'center', mt: 1 }}>{summary.needsAction}</Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                    {/* Chart for last 30 days - much wider and less tall */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Card sx={{ p: 2 }}>
                        <CardContent>
                          <Typography variant="subtitle1" sx={{ mb: 1 }}>Transactions (Last 30 Days)</Typography>
                          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <ResponsiveContainer width={900} height={120}>
                              <BarChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 10 }}>
                                <XAxis dataKey="date" tick={{ fontSize: 10 }} interval={1} />
                                <YAxis allowDecimals={false} tick={{ fontSize: 10 }} />
                                <Tooltip />
                                <Bar dataKey="count" fill="#1976d2" radius={[4, 4, 0, 0]} />
                              </BarChart>
                            </ResponsiveContainer>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                  {/* Render the latest 50 transactions table below the summary tiles */}
                  <LatestTransactionsTable />
                </Box>
              ) : page === 'notVerifiedNotImported' ? (
                <NotVerifiedNotImportedPage />
              ) : page === 'productTypeDetails' ? (
                <ProductTypeDetailsPage chartData={chartData} productTypeCategoryMap={productTypeCategoryMap} />
              ) : page === 'clientDetails' ? (
                <ClientDetailsPage />
              ) : page === 'routingRulesEditor' ? (
                <RoutingRulesEditorPage />
              // ...removed routingPOC page...
              ) : page === 'templatesAdmin' ? (
                <TemplatesAdminPage />
              ) : (
                <RecordDetailPage />
              )}
            </Box>
          } />
          {/* Record detail route */}
          <Route path="/record/:id/:client" element={<RecordDetailPage />} />
          {/* Catch-all route: redirect to root/dashboard */}
          <Route path="*" element={<Box sx={{ p: 3 }}><Typography variant="h5">Redirecting...</Typography></Box>} />
        </Routes>
      </Router>
    );
}

const msalInstance = new PublicClientApplication(msalConfig);

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <MainApp />
    </MsalProvider>
  );
}
